import React from "react";
import { format, parseISO } from "date-fns";

function dayLabel(value) {
  try {
    return format(parseISO(value), "MM/dd");
  } catch (err) {
    return value;
  }
}

export default function DaysBar({ days = [], activeDay, onSelect }) {
  return (
    <div className="w-full flex flex-row flex-wrap items-center gap-2 pt-2">
      <button
        type="button"
        onClick={() => onSelect(null)}
        className={`rounded-md px-3 py-1 border text-xs transition-all ${
          !activeDay
            ? "bg-primary text-white border-primary"
            : "bg-white text-gray-600 hover:border-primary"
        }`}
      >
        All
      </button>

      {days.map((day) => {
        const value = typeof day === "string" ? day : day.date;
        const pending = typeof day === "string" ? 0 : Number(day.pending || 0);
        const isActive = activeDay === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => onSelect(value)}
            className={`rounded-md px-3 py-1 border text-xs flex flex-row items-center gap-1 transition-all ${
              isActive
                ? "bg-primary text-white border-primary"
                : "bg-white text-gray-600 hover:border-primary"
            }`}
          >
            {dayLabel(value)}
            {pending > 0 ? (
              <span
                className={`rounded-full px-1 ${
                  isActive ? "bg-white text-primary" : "bg-red-100 text-red-600"
                }`}
              >
                {pending}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
